module.exports = __webpack_public_path__ + "media/images/browsers/dolphin-163b5642c81b7781420e2c1c6ac9d93d.svg";